import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/app/http.service';
import { ImageUploaderComponent } from 'src/app/image-uploader/image-uploader.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import * as QRCode from 'qrcode';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-front-setting',
  templateUrl: './front-setting.component.html',
  styleUrls: ['./front-setting.component.scss']
})
export class FrontSettingComponent implements OnInit, OnDestroy {

  public data: any = { template: { header: '1', content: '2', footer: '1', landing: '1' } };
  public company_uuid: any;

  readonly FOOTER_BUTTON_LABELS: Record<string, string> = {
    home: '🏠 Home',
    history: '📋 History',
    promo: '🎁 Promo',
    lucky_draw_page: '🎰 Lucky Draw Page',
    lucky_draw: '🎰 Lucky Draw',
    chat: '💬 Chat',
    setting: '⚙️ Setting',
  };

  public footerOrder: string[] = ['home', 'history', 'promo', 'lucky_draw_page', 'lucky_draw', 'chat', 'setting'];
  @ViewChild("logoUploader") logoUploader: ImageUploaderComponent
  @ViewChild("dbanner") dbanner: ImageUploaderComponent
  @ViewChild("mbanner") mbanner: ImageUploaderComponent
  @ViewChild("landingBanner") landingBanner: ImageUploaderComponent
  @ViewChild("backgroundImage") backgroundImage: ImageUploaderComponent
  @ViewChild("luckydrawImage") luckydrawImage: ImageUploaderComponent
  @ViewChild("luckyDrawPageImages") luckyDrawPageImages: ImageUploaderComponent
  @ViewChild("facebook_link") facebook_link: ImageUploaderComponent
  @ViewChild("popupbanner1") popupbanner1: ImageUploaderComponent
  @ViewChild("popupbanner2") popupbanner2: ImageUploaderComponent
  @ViewChild("faviconUploader") faviconUploader: ImageUploaderComponent
  @ViewChild("mobileAppIcon") mobileAppIcon: ImageUploaderComponent
  @ViewChild("languageEnImage") languageEnImage: ImageUploaderComponent
  @ViewChild("languageCnImage") languageCnImage: ImageUploaderComponent
  @ViewChild("languageMsImage") languageMsImage: ImageUploaderComponent
  @ViewChild("transactionTableBgImage") transactionTableBgImage: ImageUploaderComponent
  @ViewChild("transactionTableIcon") transactionTableIcon: ImageUploaderComponent
  @ViewChild("transactionTableHeadImage") transactionTableHeadImage: ImageUploaderComponent
  @ViewChild("transactionTableCol1") transactionTableCol1: ImageUploaderComponent
  @ViewChild("transactionTableCol2") transactionTableCol2: ImageUploaderComponent
  @ViewChild("fortuneFallImages") fortuneFallImages: ImageUploaderComponent
  @ViewChild("headerDesktopBackgroundImage") headerDesktopBackgroundImage: ImageUploaderComponent
  @ViewChild("headerMobileBackgroundImage") headerMobileBackgroundImage: ImageUploaderComponent
  @ViewChild("headerLeftButtonImage") headerLeftButtonImage: ImageUploaderComponent
  @ViewChild("headerLeftPopupImages") headerLeftPopupImages: ImageUploaderComponent
  @ViewChild("headerRightButtonImage") headerRightButtonImage: ImageUploaderComponent
  @ViewChild("headerRightPopupImages") headerRightPopupImages: ImageUploaderComponent

  public loading = true;
  public mobileBuildLoading = false;
  public mobileBuildResult: any = null;
  public selectedTab: string = 'general';
  public selectedPreset: string = '';
  public selectedLayout: string = '';

  get androidApkDownloadUrl(): string {
    return this.company_uuid ? `/api/player-app/${this.company_uuid}/android.apk` : '';
  }

  get mobilePlayerBuildAvailable(): boolean {
    return !environment.production;
  }

  public layoutPresets = [
    {
      id: 'classic',
      name: 'Classic',
      description: 'Simple banner + game grid',
      template: { header: '1', content: '2', footer: '1', landing: '1' },
      ascii: '┌──────────────┐\n│   Header     │\n├──────────────┤\n│   Banner     │\n├──────────────┤\n│ ■ ■ ■ ■ ■ ■ │\n│ ■ ■ ■ ■ ■ ■ │\n├──────────────┤\n│   Footer     │\n└──────────────┘'
    },
    {
      id: 'modern',
      name: 'Modern',
      description: 'Full-width banner + categories',
      template: { header: '2', content: '2', footer: '2', landing: '2' },
      ascii: '┌──────────────┐\n│   Header v2  │\n├──────────────┤\n│▓▓▓ Banner ▓▓▓│\n├──────────────┤\n│ Cat │ Cat │Cat│\n├──────────────┤\n│ ■ ■ ■ ■ ■ ■ │\n├──────────────┤\n│  Footer v2   │\n└──────────────┘'
    },
    {
      id: 'dashboard',
      name: 'Dashboard',
      description: 'Sidebar + marquee + promo',
      template: { header: '3', content: '2', footer: '2', landing: '3' },
      ascii: '┌──────────────┐\n│   Header v3  │\n├──────────────┤\n│▒▒ Marquee ▒▒▒│\n├────┬─────────┤\n│Side│ ■ ■ ■ ■ │\n│bar │ ■ ■ ■ ■ │\n│    │ Promos  │\n├────┴─────────┤\n│  Footer v2   │\n└──────────────┘'
    },
    {
      id: 'immersive',
      name: 'Immersive Hero',
      description: 'Full-width hero + sticky categories',
      template: { header: '2', content: '2', footer: '2', landing: '4' },
      ascii: '┌──────────────┐\n│   Header v2  │\n├──────────────┤\n│▓▓▓▓ HERO ▓▓▓▓│\n│▓▓▓ IMAGE ▓▓▓▓│\n├──────────────┤\n│○ Cat ○ Cat ○ │\n├──────────────┤\n│ ■ ■ ■ ■ ■ ■ │\n│ ■ ■ ■ ■ ■ ■ │\n├──────────────┤\n│  Footer v2   │\n└──────────────┘'
    },
    {
      id: 'spotlight',
      name: 'Card Spotlight',
      description: 'Rounded banner card + tab categories',
      template: { header: '1', content: '2', footer: '2', landing: '5' },
      ascii: '┌──────────────┐\n│   Header     │\n├──────────────┤\n│ ╭──────────╮ │\n│ │ Spotlight │ │\n│ ╰──────────╯ │\n│ Tab│Tab│Tab   │\n│──────────────│\n│ ■ ■ ■ ■ ■ ■ │\n├──────────────┤\n│  Footer v2   │\n└──────────────┘'
    },
    {
      id: 'mobileapp',
      name: 'Mobile App',
      description: 'App-like 2-col tiles + pill nav',
      template: { header: '2', content: '2', footer: '2', landing: '6' },
      ascii: '┌──────────────┐\n│   Header v2  │\n├──────────────┤\n│ ╭ Banner ──╮ │\n│ ╰─■■■■■■──╯ │\n│(pill)(pill)  │\n├──────────────┤\n│ ┌────┐┌────┐ │\n│ │ ■  ││ ■  │ │\n│ └────┘└────┘ │\n│ ┌────┐┌────┐ │\n│ │ ■  ││ ■  │ │\n│ └────┘└────┘ │\n├──────────────┤\n│  Footer v2   │\n└──────────────┘'
    }
  ];

  public themePresets = [
    {
      name: 'Dark Luxe Gold',
      description: 'Premium VIP feel',
      preview: { primary: '#D4AF37', secondary: '#1a1a1a', bg: '#0A0A0A', card: '#1a1a1a', text: '#ffffff', font: 'Inter, sans-serif', radius: '8px', headerBg: '#0A0A0A', footerBg: '#0A0A0A' }
    },
    {
      name: 'Neon Nightlife',
      description: 'Las Vegas energy',
      preview: { primary: '#7B2FBE', secondary: '#0B0E2D', bg: '#0B0E2D', card: '#151937', text: '#ffffff', font: "Roboto, sans-serif", radius: '16px', headerBg: '#0B0E2D', footerBg: '#0B0E2D' }
    },
    {
      name: 'Royal Emerald',
      description: 'Classic poker table',
      preview: { primary: '#0D4F2B', secondary: '#C9A84C', bg: '#0a1f12', card: '#143d23', text: '#FAF3E0', font: "'Playfair Display', serif", radius: '4px', headerBg: '#0a1f12', footerBg: '#0a1f12' }
    },
    {
      name: 'Midnight Blue',
      description: 'Modern & trustworthy',
      preview: { primary: '#1E90FF', secondary: '#0A1628', bg: '#0A1628', card: '#122240', text: '#ffffff', font: "'Open Sans', sans-serif", radius: '8px', headerBg: '#0A1628', footerBg: '#0A1628' }
    },
    {
      name: 'Red & Black',
      description: 'Bold roulette style',
      preview: { primary: '#DC143C', secondary: '#1a1a1a', bg: '#111111', card: '#1e1e1e', text: '#ffffff', font: "Roboto, sans-serif", radius: '4px', headerBg: '#111111', footerBg: '#111111' }
    },
    {
      name: 'Soft Dark',
      description: 'Modern minimal app',
      preview: { primary: '#0F3460', secondary: '#1A1A2E', bg: '#1A1A2E', card: '#16213E', text: '#e0e0e0', font: "Inter, sans-serif", radius: '16px', headerBg: '#1A1A2E', footerBg: '#1A1A2E' }
    }
  ];

  // WhatsApp channel (chat)
  public waStatus: string = '';
  public waQRCode: string = '';
  public waLoading: boolean = false;
  private waQRInterval: any = null;

  // WhatsApp TAC session linking
  public tacWaStatus: 'unknown' | 'not_linked' | 'loading' | 'qr_pending' | 'linked' = 'unknown';
  public tacWaQRCode: string = '';
  public tacWaLoading: boolean = false;
  private tacWaInterval: any = null;
  private tacWaHeartbeatInterval: any = null;
  private tacWaNoQRCount: number = 0;
  private tacWaPrevLinked: boolean = false;

  // WhatsApp test-message form
  public tacWaTestPhone: string = '';
  public tacWaTestMessage: string = 'This is a test message from the panel.';
  public tacWaTestSending: boolean = false;
  public tacWaTestResult: { ok: boolean; message: string } | null = null;


  constructor(private http: HttpService, private route: ActivatedRoute, private router: Router) {
    this.company_uuid = this.http.getStaticSelectedCompany();
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['tab']) {
        this.selectedTab = params['tab'];
      } else {
        this.selectTab('general');
      }
    });
    this.init();
  }

  selectTab(tabId: string) {
    this.selectedTab = tabId;
    this.router.navigate(['/lo', this.company_uuid, 'front', 'setting', tabId]);
  }

  applyPreset(preset: any) {
    this.data.theme_primary_color = preset.preview.primary;
    this.data.theme_primary_text_color = preset.preview.text;
    this.data.theme_secondary_color = preset.preview.secondary;
    this.data.theme_card_background_color = preset.preview.card;
    this.data.theme_font_family = preset.preview.font;
    this.data.theme_border_radius = preset.preview.radius;
    this.data.background_color = preset.preview.bg;
    this.data.header_background_color = preset.preview.headerBg;
    this.data.footer_background_color = preset.preview.footerBg;
    this.selectedPreset = preset.name;
  }

  applyLayout(layout: any) {
    if (!this.data.template || typeof this.data.template !== 'object') {
      this.data.template = {};
    }
    this.data.template = { ...this.data.template, ...layout.template };
    this.selectedLayout = layout.id;
  }

  async init() {
    this.loading = true;
    this.data = await this.http.post("/admin/setting/get");
    if (!this.data.logo_size) {
      this.data.logo_size = '100px';
    }

    if (!this.data.live_transaction_source) {
      this.data.live_transaction_source = 'real_wins';
    }

    if (!this.data.agent_account_period) {
      this.data.agent_account_period = 'current_month';
    }

    // Red Share Mode: seed a definite value so the Yes/No selector renders correctly.
    // Engine default when unset is "included" (the 红股 worked example counts the
    // agent's own bet), so default the selector to Yes.
    if (this.data.agent_red_share_include_own_deposit === undefined ||
        this.data.agent_red_share_include_own_deposit === null) {
      this.data.agent_red_share_include_own_deposit = 'true';
    }

    if (this.data.enabled_frontend_apk_download === undefined) {
      this.data.enabled_frontend_apk_download = 'false';
    }

    if (!this.data.frontend_apk_download_label) {
      this.data.frontend_apk_download_label = 'Download App';
    }

    if (!this.data.mobile_app_name) {
      this.data.mobile_app_name = this.data.brand_name || '';
    }
    delete this.data.frontend_apk_download_url;

    // Initialize template object
    if (!this.data.template || typeof this.data.template !== 'object') {
      this.data.template = { header: '1', content: '1', footer: '1', landing: '1' };
    }

    // Detect current layout preset
    const tpl = this.data.template;
    const match = this.layoutPresets.find(lp =>
      lp.template.header === tpl.header &&
      lp.template.footer === tpl.footer &&
      lp.template.landing === tpl.landing
    );
    if (match) {
      this.selectedLayout = match.id;
    }

    if (!this.data.clear_balance_limit) {
      this.data.clear_balance_limit = 5;
    }

    // Footer order — parse saved JSON or fall back to default
    if (this.data.footer_order) {
      try {
        const parsed = typeof this.data.footer_order === 'string'
          ? JSON.parse(this.data.footer_order)
          : this.data.footer_order;
        if (Array.isArray(parsed)) this.footerOrder = parsed;
      } catch (_) {}
    }
    this.footerOrder = [
      ...this.footerOrder,
      ...Object.keys(this.FOOTER_BUTTON_LABELS).filter(key => !this.footerOrder.includes(key))
    ];

    // Dedicated Table Settings
    if (this.data.live_transaction_table_border === undefined) {
      this.data.live_transaction_table_border = 'true';
    }
    if (this.data.live_transaction_table_border_size === undefined) {
      this.data.live_transaction_table_border_size = 1;
    }
    if (!this.data.live_transaction_table_border_color) {
      this.data.live_transaction_table_border_color = '#ed1f27';
    }
    if (!this.data.live_transaction_table_font_size) {
      this.data.live_transaction_table_font_size = 14;
    }

    if (this.data.logo) {
      this.logoUploader.files = [this.data.logo]
    }

    if (this.data.favicon) {
      this.faviconUploader.files = [this.data.favicon]
    }

    if (this.data.dbanner) {
      this.dbanner.files = this.data.dbanner
    }

    if (this.data.mbanner) {
      this.mbanner.files = this.data.mbanner
    }

    if (this.data.facebook_link) {
      this.facebook_link.files = this.data.facebook_link;
    }

    if (this.data.background_image) {
      this.backgroundImage.files = this.data.background_image;
    }

    if (this.data.lucky_draw_image) {
      this.luckydrawImage.files = this.data.lucky_draw_image
    }

    if (this.data.lucky_draw_page_images) {
      this.luckyDrawPageImages.files = this.data.lucky_draw_page_images
    }

    if (this.data.popupbanner1) {
      this.popupbanner1.files = this.data.popupbanner1
    }

    if (this.data.popupbanner2) {
      this.popupbanner2.files = this.data.popupbanner2
    }

    if (this.data.language_en_image) {
      this.languageEnImage.files = [this.data.language_en_image]
    }

    if (this.data.language_cn_image) {
      this.languageCnImage.files = [this.data.language_cn_image]
    }

    if (this.data.language_ms_image) {
      this.languageMsImage.files = [this.data.language_ms_image]
    }

    if (this.data.transaction_table_background_image) {
      this.transactionTableBgImage.files = [this.data.transaction_table_background_image]
    }

    if (this.data.transaction_table_icon) {
      this.transactionTableIcon.files = [this.data.transaction_table_icon]
    }

    if (this.data.transaction_table_head) {
      this.transactionTableHeadImage.files = [this.data.transaction_table_head]
    }

    if (this.data.live_transaction_table_col1_image) {
      this.transactionTableCol1.files = [this.data.live_transaction_table_col1_image]
    }

    if (this.data.live_transaction_table_col2_image) {
      this.transactionTableCol2.files = [this.data.live_transaction_table_col2_image]
    }

    if (this.data.fortune_fall_images && this.data.fortune_fall_images.length > 0) {
      this.fortuneFallImages.files = [...this.data.fortune_fall_images]
    }

    if (this.data.header_desktop_background_image) {
      this.headerDesktopBackgroundImage.files = [this.data.header_desktop_background_image]
    }

    if (this.data.header_mobile_background_image || this.data.header_background_image) {
      this.headerMobileBackgroundImage.files = [this.data.header_mobile_background_image || this.data.header_background_image]
    }

    if (this.data.header_left_button_image) {
      this.headerLeftButtonImage.files = [this.data.header_left_button_image]
    }

    if (this.data.header_left_popup_images) {
      this.headerLeftPopupImages.files = this.data.header_left_popup_images
    }

    if (this.data.header_right_button_image) {
      this.headerRightButtonImage.files = [this.data.header_right_button_image]
    }

    if (this.data.header_right_popup_images) {
      this.headerRightPopupImages.files = this.data.header_right_popup_images
    }

    this.loading = false;

    // Check WhatsApp channel status
    this.checkWhatsAppStatus();

    // Check TAC WhatsApp session status if provider is set
    if (this.data.sms_provider === 'whatsapp_web' || this.data.sms_provider === 'app_whatsapp_web') {
      this.checkTacWhatsAppStatus();
    }
  }

  onFooterDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.footerOrder, event.previousIndex, event.currentIndex);
    this.data.footer_order = JSON.stringify(this.footerOrder);
  }

  async submit() {
    if (this.loading) {
      return;
    }
    // Persist latest footer order before saving
    this.data.footer_order = JSON.stringify(this.footerOrder);
    const payload = { ...this.data };
    delete payload.frontend_apk_download_url;
    const t = await this.http.post("/admin/setting/save", payload);
    this.http.notify("Data update successfully.")
  }

  async regenerateAndroidApk() {
    if (this.loading || this.mobileBuildLoading) {
      return;
    }

    this.mobileBuildLoading = true;
    this.mobileBuildResult = null;
    this.data.footer_order = JSON.stringify(this.footerOrder);
    const payload = { ...this.data };
    delete payload.frontend_apk_download_url;
    await this.http.post("/admin/setting/save", payload);
    const result: any = await this.http.post("/admin/mobile-player/regenerate", { platform: 'android' });
    this.mobileBuildResult = result || { status: false, message: 'Build failed — see error toast. The build host may be unavailable or missing the mobile-player toolchain.' };

    if (result?.status) {
      this.data.mobile_android_apk_s3_key = result.s3_key;
      this.data.mobile_android_apk_built_at = result.built_at;
    }

    this.mobileBuildLoading = false;
  }

  async prepareIosConfig() {
    if (this.loading || this.mobileBuildLoading) {
      return;
    }

    this.mobileBuildLoading = true;
    this.mobileBuildResult = null;
    this.data.footer_order = JSON.stringify(this.footerOrder);
    const payload = { ...this.data };
    delete payload.frontend_apk_download_url;
    await this.http.post("/admin/setting/save", payload);
    const result: any = await this.http.post("/admin/mobile-player/regenerate", { platform: 'ios' });
    this.mobileBuildResult = result || { status: false, message: 'Build failed — see error toast. The build host may be unavailable or missing the mobile-player toolchain.' };
    this.mobileBuildLoading = false;
  }

  isNumericId(value: any): boolean {
    return /^\d+$/.test(String(value || '').trim());
  }

  upload(data: any, key: string, single = false) {
    this.data[key] = (single) ? data[0] : data
  }

  delete(data: any, key: string) {
    this.data[key] = data
  }

  editorCreated(quill: any, param: any) {
    setTimeout(() => {
      quill.clipboard.dangerouslyPasteHTML(this.data[param]);
    }, 1000)
  }

  public pairingCode: string = "";

  async generatePairingCode() {
    this.loading = true;
    const res: any = await this.http.post("/admin/setting/generate-pairing-code");
    if (res.status) {
      this.pairingCode = res.code;
    }
    this.loading = false;
  }

  openFormulaBuilder() {

  }

  // --- WhatsApp Channel Methods ---

  async checkWhatsAppStatus() {
    try {
      const res: any = await this.http.post('/admin/chat/whatsapp/status');
      this.waStatus = res.connection_status || 'not_configured';

      if (this.waStatus === 'qr_needed') {
        this.startQRPolling();
      }
    } catch (e) {
      this.waStatus = 'not_configured';
    }
  }

  async initWhatsApp() {
    this.waLoading = true;
    try {
      const res: any = await this.http.post('/admin/chat/whatsapp/init', { config: {} });
      if (res.status) {
        this.waStatus = 'qr_needed';
        this.startQRPolling();
      }
    } catch (e) {
      console.error('WhatsApp init error:', e);
    }
    this.waLoading = false;
  }

  async refreshWhatsAppQR() {
    try {
      const res: any = await this.http.post('/admin/chat/whatsapp/qr');
      if (res.status && res.qr) {
        this.waQRCode = await QRCode.toDataURL(res.qr, { width: 280, margin: 2 });
      } else {
        this.waStatus = res.connection_status || this.waStatus;
        if (this.waStatus === 'connected') {
          this.stopQRPolling();
          this.waQRCode = '';
        }
      }
    } catch (e) {
      console.error('QR fetch error:', e);
    }
  }

  startQRPolling() {
    this.stopQRPolling();
    this.refreshWhatsAppQR();
    this.waQRInterval = setInterval(async () => {
      await this.refreshWhatsAppQR();
      // Also check connection status
      const res: any = await this.http.post('/admin/chat/whatsapp/status');
      if (res.connection_status === 'connected') {
        this.waStatus = 'connected';
        this.waQRCode = '';
        this.stopQRPolling();
      }
    }, 5000);
  }

  stopQRPolling() {
    if (this.waQRInterval) {
      clearInterval(this.waQRInterval);
      this.waQRInterval = null;
    }
  }

  async disconnectWhatsApp() {
    try {
      await this.http.post('/admin/chat/whatsapp/disconnect');
      this.waStatus = 'disconnected';
      this.waQRCode = '';
      this.stopQRPolling();
    } catch (e) {
      console.error('WhatsApp disconnect error:', e);
    }
  }

  // --- WhatsApp TAC session linking ---

  private setTacWaStatus(status: 'unknown' | 'not_linked' | 'loading' | 'qr_pending' | 'linked') {
    const dropped = this.tacWaPrevLinked && status !== 'linked';
    this.tacWaStatus = status;
    this.tacWaPrevLinked = status === 'linked';
    if (dropped) {
      this.stopTacHeartbeat();
      this.http.notifyPersistentError(
        'WhatsApp TAC session has disconnected. Players cannot receive OTP via WhatsApp until re-linked.',
        'WhatsApp Disconnected',
        'toast-wa-drop'
      );
    }
    if (status === 'linked') {
      this.startTacHeartbeat();
    }
  }

  private startTacHeartbeat() {
    if (this.tacWaHeartbeatInterval) return;
    this.tacWaHeartbeatInterval = setInterval(async () => {
      try {
        const res: any = await this.http.post('/admin/whatsapp-tac/status').catch(() => ({}));
        if (!res.connected) {
          this.setTacWaStatus('not_linked');
        }
      } catch (_) {}
    }, 30000);
  }

  private stopTacHeartbeat() {
    if (this.tacWaHeartbeatInterval) {
      clearInterval(this.tacWaHeartbeatInterval);
      this.tacWaHeartbeatInterval = null;
    }
  }

  async checkTacWhatsAppStatus() {
    try {
      const res: any = await this.http.post('/admin/whatsapp-tac/status');
      if (!res.configured) {
        this.setTacWaStatus('not_linked');
        return;
      }
      if (res.connected) {
        this.setTacWaStatus('linked');
        this.tacWaQRCode = '';
        this.stopTacQRPolling();
      } else if (res.qrPending) {
        this.setTacWaStatus('qr_pending');
        this.startTacQRPolling();
      } else {
        this.setTacWaStatus('not_linked');
      }
    } catch (_) {
      this.setTacWaStatus('not_linked');
    }
  }

  async initTacWhatsApp() {
    this.tacWaLoading = true;
    this.setTacWaStatus('loading');
    try {
      const res: any = await this.http.post('/admin/whatsapp-tac/init');
      if (!res || !res.status) {
        const errMsg = res?.error || 'Could not link to WhatsApp. Please try again later.';
        alert(errMsg);
        this.setTacWaStatus('not_linked');
      } else {
        this.setTacWaStatus('qr_pending');
        this.startTacQRPolling();
      }
    } catch (e) {
      console.error('TAC WhatsApp init error:', e);
      this.setTacWaStatus('not_linked');
    }
    this.tacWaLoading = false;
  }

  async refreshTacWhatsAppQR() {
    try {
      const res: any = await this.http.post('/admin/whatsapp-tac/qr');
      if (res.connected) {
        this.setTacWaStatus('linked');
        this.tacWaQRCode = '';
        this.tacWaNoQRCount = 0;
        this.stopTacQRPolling();
        return;
      }
      if (res.qr) {
        this.tacWaQRCode = res.qr;
        this.setTacWaStatus('qr_pending');
        this.tacWaNoQRCount = 0;
      } else {
        this.tacWaNoQRCount++;
        // Session died (auth timeout) — reset so user can re-link
        if (this.tacWaNoQRCount >= 4) {
          this.setTacWaStatus('not_linked');
          this.tacWaQRCode = '';
          this.tacWaNoQRCount = 0;
          this.stopTacQRPolling();
        }
      }
    } catch (_) {}
  }

  startTacQRPolling() {
    this.stopTacQRPolling();
    this.tacWaNoQRCount = 0;
    this.refreshTacWhatsAppQR();
    this.tacWaInterval = setInterval(async () => {
      const statusRes: any = await this.http.post('/admin/whatsapp-tac/status').catch(() => ({}));
      if (statusRes.connected) {
        this.setTacWaStatus('linked');
        this.tacWaQRCode = '';
        this.tacWaNoQRCount = 0;
        this.stopTacQRPolling();
      } else {
        await this.refreshTacWhatsAppQR();
      }
    }, 5000);
  }

  async sendTacTestMessage() {
    this.tacWaTestResult = null;

    const phone = (this.tacWaTestPhone || '').trim();
    const text = (this.tacWaTestMessage || '').trim();

    if (!phone) {
      this.tacWaTestResult = { ok: false, message: 'Please enter a phone number.' };
      return;
    }
    if (!text) {
      this.tacWaTestResult = { ok: false, message: 'Please enter a message.' };
      return;
    }

    this.tacWaTestSending = true;
    try {
      const res: any = await this.http.post('/admin/whatsapp-tac/send-test', { phone, text });
      if (res?.status) {
        this.tacWaTestResult = { ok: true, message: 'Test message sent successfully.' };
      } else {
        this.tacWaTestResult = { ok: false, message: res?.error || 'Failed to send test message.' };
      }
    } catch (e: any) {
      this.tacWaTestResult = { ok: false, message: e?.message || 'Failed to send test message.' };
    }
    this.tacWaTestSending = false;
  }

  async logoutTacWhatsApp() {
    this.tacWaLoading = true;
    try {
      await this.http.post('/admin/whatsapp-tac/logout');
      this.setTacWaStatus('not_linked');
      this.tacWaQRCode = '';
      this.stopTacQRPolling();
    } catch (e) {
      console.error('TAC WhatsApp logout error:', e);
    }
    this.tacWaLoading = false;
  }

  stopTacQRPolling() {
    if (this.tacWaInterval) {
      clearInterval(this.tacWaInterval);
      this.tacWaInterval = null;
    }
    this.tacWaNoQRCount = 0;
  }

  ngOnDestroy() {
    this.stopQRPolling();
    this.stopTacQRPolling();
    this.stopTacHeartbeat();
  }
}
